import { useCallback, useEffect, useState } from 'react';
import { useApi } from './useApi';
import type { Project } from '@pantheon/shared';

export function useProjects() {
  const { get } = useApi();
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    setError(null);
    const result = await get<Project[]>('/projects');
    if (result.success && result.data) {
      setProjects(result.data);
    } else {
      setError(result.error?.message ?? 'Failed to load projects');
    }
    setLoading(false);
  }, [get]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { projects, loading, error, refetch: fetchProjects };
}
